import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import { u3125FormatCurrency } from "../../../../U3125";
import type { U3125InvoicePaymentGridRow } from "../../../../U3125Service";
import type { U3125PaymentHandlerReturn } from "./U3125PaymentHandlers";

interface U3125PaymentDeleteDlgProps {
  u3125PaymentHandler: U3125PaymentHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3125PaymentDeleteDlg({ u3125PaymentHandler, t, NS }: U3125PaymentDeleteDlgProps) {
  if (!u3125PaymentHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={u3125PaymentHandler.isDeleteDialogOpen}
      onClose={u3125PaymentHandler.onDlgDeleteClose}
      title={t("sectionPayments", { ns: NS })}
    >
      <p className="mb-4">
        {t("msgDeletePayments", {
          count: u3125PaymentHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3125PaymentHandler.gridStateHandlers.getSelectedRows().map((row: U3125InvoicePaymentGridRow, index: number, array: U3125InvoicePaymentGridRow[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.paymentTypeCode ?? ""} — ${u3125FormatCurrency(row.amountTotal)}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3125PaymentDeleteDlg;
